/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Here mentioned rate calendar feature request structure
 */
const API = {
  GET_EVENTS: {
    path: '/organizations/:organizationId/hotels/:hotelId/events?:query',
    method: 'GET',
  },
  GET_EVENT: {
    path: '/organizations/:organizationId/hotels/:hotelId/events/:id',
    method: 'GET',
  },
  GET_FORECAST_CONSTRAINT: {
    path: '/organizations/:organizationId/hotels/:hotelId/forecast-constraints?:query',
    method: 'GET',
  },
  GET_FORECAST_RATE: {
    path: '/organizations/:organizationId/hotels/:hotelId/forecast-rates?:query',
    method: 'GET',
  },
  GET_HOTEL: {
    path: '/organizations/:organizationId/hotels/:hotelId',
    method: 'GET',
  },
  GET_ROOM_CONSUMPTION_DATA: {
    path: '/organizations/:organizationId/hotels/:hotelId/room-consumption-data?:query',
    method: 'GET',
  },
  POST_EVENT: {
    path: '/organizations/:organizationId/hotels/:hotelId/events',
    method: 'POST',
  },
  PATCH_EVENT: {
    path: '/organizations/:organizationId/hotels/:hotelId/events/:id',
    method: 'PATCH',
  },
  PATCH_FORECAST_CONSTRAINT: {
    path: '/organizations/:organizationId/hotels/:hotelId/forecast-constraint/:id',
    method: 'PATCH',
  },
  PATCH_FORECAST_RATE: {
    path: '/organizations/:organizationId/hotels/:hotelId/forecast-rate/:id',
    method: 'PATCH',
  },
  DELETE_EVENT: {
    path: '/organizations/:organizationId/hotels/:hotelId/events/:id',
    method: 'DELETE',
  },
  GET_MINOR_EVENT_CATEGORIES: {
    path: '/organizations/:organizationId/major-event-categories/:majorEventCategoryId/minor-event-categories?:query',
    method: 'GET',
  },
  GET_MAJOR_EVENT_CATEGORIES: {
    path: '/organizations/:organizationId/major-event-categories?:query',
    method: 'GET',
  },
};
//
export default API;
